import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { LoadingState } from "../components/LoadingState";
import { HomePage } from "../features/home/HomePage";

const AdminSettingsPage = lazy(() =>
	import("../features/admin/AdminSettingsPage").then((module) => ({
		default: module.AdminSettingsPage,
	})),
);
const AuditLogPage = lazy(() =>
	import("../features/admin/AuditLogPage").then((module) => ({ default: module.AuditLogPage })),
);
const AnalyticsPage = lazy(() =>
	import("../features/admin/AnalyticsPage").then((module) => ({ default: module.AnalyticsPage })),
);
const ContactContentPage = lazy(() =>
	import("../features/admin/ContactContentPage").then((module) => ({
		default: module.ContactContentPage,
	})),
);
const CalendarPage = lazy(() =>
	import("../features/admin/CalendarPage").then((module) => ({
		default: module.CalendarPage,
	})),
);
const FollowUpsPage = lazy(() =>
	import("../features/admin/FollowUpsPage").then((module) => ({ default: module.FollowUpsPage })),
);
const InvitationsPage = lazy(() =>
	import("../features/admin/InvitationsPage").then((module) => ({
		default: module.InvitationsPage,
	})),
);
const OperationsPage = lazy(() =>
	import("../features/admin/OperationsPage").then((module) => ({ default: module.OperationsPage })),
);
const MessagesPage = lazy(() =>
	import("../features/admin/MessagesPage").then((module) => ({ default: module.MessagesPage })),
);
const StaffPage = lazy(() =>
	import("../features/admin/StaffPage").then((module) => ({ default: module.StaffPage })),
);
const SurveySetsPage = lazy(() =>
	import("../features/admin/SurveySetsPage").then((module) => ({ default: module.SurveySetsPage })),
);
const SurveyPage = lazy(() =>
	import("../features/survey/SurveyPage").then((module) => ({ default: module.SurveyPage })),
);
const ThanksPage = lazy(() =>
	import("../features/survey/ThanksPage").then((module) => ({ default: module.ThanksPage })),
);

export function App() {
	return (
		<Suspense fallback={<LoadingState label="화면을 준비하고 있습니다" />}>
			<Routes>
				<Route path="/" element={<HomePage />} />
				<Route path="/s/:token" element={<SurveyPage />} />
				<Route path="/thanks" element={<ThanksPage />} />
				<Route path="/admin" element={<Navigate to="/admin/operations" replace />} />
				<Route path="/admin/operations" element={<OperationsPage />} />
				<Route path="/admin/calendar" element={<CalendarPage />} />
				<Route path="/admin/messages" element={<MessagesPage />} />
				<Route path="/admin/survey-sets" element={<SurveySetsPage />} />
				<Route path="/admin/staff" element={<StaffPage />} />
				<Route path="/admin/content" element={<ContactContentPage />} />
				<Route path="/admin/invitations" element={<InvitationsPage />} />
				<Route path="/admin/follow-ups" element={<FollowUpsPage />} />
				<Route path="/admin/analytics" element={<AnalyticsPage />} />
				<Route path="/admin/audit" element={<AuditLogPage />} />
				<Route path="/admin/settings" element={<AdminSettingsPage />} />
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</Suspense>
	);
}
